var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "resources-vue" } },
    [
      _c("div", { staticClass: "mdc-tab-container" }, [
        _c(
          "div",
          { staticClass: "mdc-tab-scroller" },
          [
            _vm._l(_vm.mdcTabs, function(mdcTab) {
              return _c(
                "a",
                {
                  key: mdcTab.id,
                  staticClass: "mdc-tab tabResources",
                  class: { active: mdcTab.isActive },
                  attrs: {
                    href: mdcTab.link,
                    "data-term": mdcTab.slug,
                    "data-termid": mdcTab.id
                  }
                },
                [
                  _c("span", { staticClass: "mdc-tab-label" }, [
                    _c("span", { staticClass: "count" }, [
                      _vm._v(_vm._s(mdcTab.order + "."))
                    ]),
                    _vm._v(
                      "\n                    " +
                        _vm._s(mdcTab.name) +
                        "\n                "
                    )
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "search-container resourcesserch" }, [
              _c("input", {
                staticClass: "elemserch keyupVal",
                attrs: {
                  id: "resourcesserch",
                  placeholder: _vm.tr.search,
                  value: ""
                },
                on: {
                  keyup: function($event) {
                    if (!$event.type.indexOf("key") && $event.keyCode !== 13) {
                      return null
                    }
                    return _vm.applyResourceFilter($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "s-close",
                on: { click: _vm.clearResourceFilter }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "line" })
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mdc-tag-container",
          attrs: { id: "res-tag-container" }
        },
        [
          _vm._l(_vm.resTags, function(resTag) {
            return _c(
              "a",
              {
                key: resTag.id,
                staticClass: "mdc-tag resTerm",
                class: {
                  active: resTag.isActive,
                  "all-files": resTag.id === 0
                },
                attrs: {
                  "data-id": resTag.id,
                  "data-slug": resTag.slug,
                  href: resTag.link
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onTagClick(resTag, $event)
                  }
                }
              },
              [
                resTag.id === 0
                  ? _c("span", [_vm._v(_vm._s(_vm.tr.all_files))])
                  : _c("span", [
                      _vm._v(
                        "\n                " +
                          _vm._s(resTag.name) +
                          "\n                "
                      ),
                      _c(
                        "svg",
                        {
                          staticClass: "svg-inline--fa fa-times-circle fa-w-16",
                          attrs: {
                            "aria-hidden": "true",
                            focusable: "false",
                            "data-prefix": "fas",
                            "data-icon": "times-circle",
                            role: "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 512 512"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "currentColor",
                              d:
                                "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                            }
                          })
                        ]
                      )
                    ])
              ]
            )
          }),
          _vm._v(" "),
          _vm.isMultiSelect
            ? _c(
                "a",
                {
                  staticClass: "mdc-tag resTerm",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onClearAll.apply(null, arguments)
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(_vm.tr.clear_all))])]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block-post-res", attrs: { id: "resources-res" } },
        [
          _vm._l(_vm.displayPosts, function(post) {
            return _c(
              "div",
              {
                key: post.title,
                staticClass: "col-xl-4 col-md-6 col-12 post-item"
              },
              [
                _c("div", { staticClass: "post-item-wrap" }, [
                  _c("div", { staticClass: "wrap-post-image" }, [
                    _c("a", { attrs: { href: post.link } }, [
                      post.thumbnail
                        ? _c("div", {
                            staticClass: "post-image",
                            style: _vm.postImageStyle(post.thumbnail)
                          })
                        : _c("div", {
                            staticClass: "post-image",
                            style: _vm.postImageStyle(
                              _vm.constLinks.default_post_img
                            )
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "download-icon" }, [
                        post.is_video
                          ? _c("img", {
                              attrs: {
                                src: _vm.constLinks.ic_video_play,
                                alt: "Icon"
                              }
                            })
                          : _c("img", {
                              attrs: {
                                src: _vm.constLinks.ic_file_download,
                                alt: "Icon"
                              }
                            })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "post-category" },
                    [
                      _c("a", { staticClass: "link-category" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(post.post_type) +
                            " |\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(post.post_tags, function(post_tag) {
                        return _c(
                          "a",
                          {
                            key: post_tag.slug,
                            staticClass: "link-category",
                            attrs: { href: "#", "data-slug": post_tag.slug }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(post_tag.name) +
                                "\n                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "post-description" }, [
                    _c("a", { attrs: { href: post.link } }, [
                      _c("h3", { staticClass: "h5 title-post" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(post.title) +
                            "\n                    "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-editor" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(post.excerpt) +
                          "\n                "
                      )
                    ])
                  ])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _vm.showMoreBtn
            ? _c(
                "div",
                {
                  staticClass: "col-12 loadmore_btn_wrap",
                  on: { click: _vm.onClickShowMore }
                },
                [
                  _c("div", { staticClass: "loadmore_btn loadresources" }, [
                    _vm._v(_vm._s(_vm.tr.show_more))
                  ])
                ]
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40740b5c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40740b5c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./App/components/ResourceList/ResourceList.vue
// module id = 662
// module chunks = 1